import {
  Utensils, Pizza, Coffee, Martini, IceCreamCone, ShoppingBag, Umbrella,
  Landmark, Binoculars, TreePine, ShoppingCart, Cross, MapPin,
} from "lucide-react";

// Colori e icone delle categorie — da tabella del prompt "Mappa dei consigli".
// Le categorie non in tabella usano il grigio con il segnaposto generico.
const GENERIC = { color: "#6B6458", Icon: MapPin, key: "generic" };

// Matcher per parola chiave: le categorie dell'editor sono in italiano
// (Ristorante, Pizzeria, Pub, Bar, Gelateria, ...), ma accettiamo anche varianti.
const RULES = [
  { kw: ["ristor", "trattor", "osteria", "restaurant"], color: "#D9363E", Icon: Utensils, key: "ristorante" },
  { kw: ["pizz"], color: "#E8642C", Icon: Pizza, key: "pizzeria" },
  { kw: ["gelat", "ice cream", "gelato"], color: "#E5478B", Icon: IceCreamCone, key: "gelato" },
  { kw: ["aperit", "cocktail", "vino", "wine", "enotec", "pub", "birr", "locale nott", "nightlife", "disco"], color: "#7B3FA0", Icon: Martini, key: "aperitivo" },
  { kw: ["bar", "caff", "coffee", "colazion", "breakfast", "pasticc", "forn", "panett", "bakery"], color: "#9A5B2E", Icon: Coffee, key: "bar" },
  { kw: ["supermerc", "market", "mercat", "grocery", "aliment"], color: "#16857C", Icon: ShoppingCart, key: "supermercato" },
  { kw: ["farmac", "pharma"], color: "#1E9E57", Icon: Cross, key: "farmacia" },
  { kw: ["shop", "negozi", "store", "boutique"], color: "#2F5BD9", Icon: ShoppingBag, key: "shopping" },
  { kw: ["spiag", "beach", "mare", "lido"], color: "#0F9BB5", Icon: Umbrella, key: "spiaggia" },
  { kw: ["muse", "cultur", "gallery", "teatro", "chiesa", "monument"], color: "#5B4BB7", Icon: Landmark, key: "museo" },
  { kw: ["panoram", "vista", "belveder", "escursion", "trekking", "hike", "mountain", "viewpoint"], color: "#E89A1C", Icon: Binoculars, key: "panorama" },
  { kw: ["parc", "park", "giardin", "natur", "verde"], color: "#2E8B4A", Icon: TreePine, key: "parco" },
];

export function resolveCategoryStyle(category) {
  const t = (category || "").toLowerCase().trim();
  if (!t) return GENERIC;
  for (const r of RULES) {
    if (r.kw.some((k) => t.includes(k))) return { color: r.color, Icon: r.Icon, key: r.key };
  }
  return GENERIC;
}

export const CATEGORY_GENERIC = GENERIC;
